<template>
  <footer class="footer">
    <div class="footer-links">
      <router-link to="/datenschutz/">Datenschutz</router-link> - 
      <router-link to="/Impressum/">Impressum</router-link> - 
      <router-link to="/kontakt/">Kontakt</router-link>
    </div>
    <div class="footer-copyright">
      Copyright &copy; 2025&ndash;{{ currentYear }} Maike Röhrig - Maikes Familienbegleitung. Alle Rechte vorbehalten.
    </div>
    <div class="footer-social">
      <a href="https://maikes-familienbegleitung.de" aria-label="Zur Website von Maikes Familienbegleitung" target="_blank" rel="noopener">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" role="img" aria-label="Homepage-Symbol">
          <path fill="black" d="M20,0H4C1.8,0,0,1.8,0,4v16c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4V4C24,1.8,22.2,0,20,0z"/>
          <g fill="none" stroke="var(--primary-color)" stroke-linecap="round" stroke-linejoin="round">
            <path stroke-width="1.5" d="M12,2.5a9.5,9.5 0 1,0 0.1,0z"/>
            <path stroke-width="1" d="m12,2.5v19m9.5-9.5H2.5M4.5,6a12,12 0 0,0 15,0 m0,12 a12,12 0 0,0-15,0M10,3a13,13 0 0,0 0,18 m4,0 a13,13 0 0,0 0-18"/>
          </g>
        </svg>
      </a>
      <a href="https://www.instagram.com/maikes_familienbegleitung" aria-label="Maikes Familienbegleitung bei Instagram" target="_blank" rel="noopener">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" role="img" aria-label="Instagram-Symbol">
          <g>
            <path d="M12,9c-1.7,0-3,1.3-3,3s1.3,3,3,3c1.7,0,3-1.3,3-3C15,10.3,13.6,9,12,9z">
            </path>
            <path d="M20,0H4C1.8,0,0,1.8,0,4v16c0,2.2,1.8,4,4,4h16c2.2,0,4-1.8,4-4V4C24,1.8,22.2,0,20,0z M20.9,15.7c0,0.7-0.2,1.5-0.4,2.2
              c-0.5,1.2-1.4,2.2-2.6,2.6c-0.7,0.3-1.4,0.4-2.2,0.4c-1,0-1.3,0.1-3.7,0.1s-2.8,0-3.7-0.1c-0.7,0-1.5-0.2-2.2-0.4
              c-1.2-0.5-2.2-1.4-2.6-2.6c-0.3-0.7-0.4-1.4-0.4-2.2C3,14.8,3,14.4,3,12s0-2.8,0.1-3.7c0-0.7,0.2-1.5,0.4-2.2
              c0.5-1.2,1.4-2.2,2.6-2.6c0.7-0.3,1.4-0.4,2.2-0.4C9.2,3,9.6,3,12,3s2.8,0,3.7,0.1c0.7,0,1.5,0.2,2.2,0.4c1.2,0.5,2.2,1.4,2.6,2.6
              c0.3,0.7,0.4,1.4,0.4,2.2c0,1,0.1,1.3,0.1,3.7S21,14.8,20.9,15.7z">
            </path>
            <path d="M19.3,8.4c0-0.6-0.1-1.1-0.3-1.7c-0.1-0.4-0.4-0.7-0.7-1c-0.3-0.3-0.6-0.5-1-0.7c-0.5-0.2-1.1-0.3-1.7-0.3
              c-0.9,0-1.2-0.1-3.6-0.1c-2.4,0-2.7,0-3.6,0.1C7.8,4.7,7.2,4.8,6.7,5c-0.4,0.1-0.7,0.4-1,0.7C5.4,5.9,5.1,6.3,5,6.7
              C4.8,7.2,4.7,7.8,4.7,8.4c0,0.9-0.1,1.2-0.1,3.6c0,2.4,0,2.7,0.1,3.6c0,0.6,0.1,1.1,0.3,1.7c0.1,0.4,0.4,0.7,0.7,1
              c0.3,0.3,0.6,0.5,1,0.7c0.5,0.2,1.1,0.3,1.7,0.3c0.9,0,1.2,0.1,3.6,0.1c2.4,0,2.7,0,3.6-0.1c0.6,0,1.1-0.1,1.7-0.3
              c0.4-0.1,0.7-0.4,1-0.7c0.3-0.3,0.5-0.6,0.7-1c0.2-0.5,0.3-1.1,0.3-1.7l0,0c0-0.9,0.1-1.2,0.1-3.6C19.4,9.6,19.4,9.3,19.3,8.4z
              M12,16.6c-2.6,0-4.6-2.1-4.6-4.6S9.4,7.4,12,7.4c2.6,0,4.6,2.1,4.6,4.6C16.6,14.6,14.5,16.6,12,16.6z M16.8,8.3
              c-0.6,0-1.1-0.5-1.1-1.1c0-0.6,0.5-1.1,1.1-1.1c0.6,0,1.1,0.5,1.1,1.1C17.9,7.8,17.4,8.3,16.8,8.3z">
            </path>
          </g>
        </svg>
      </a>
      <a href="mailto:info@maikes-familienbegleitung.de" aria-label="E-Mail an Maikes Familienbegleitung" target="_blank" rel="noopener">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" role="img" aria-label="E-Mail-Symbol">
          <path d="M20,24H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v16C24,22.2,22.2,24,20,24z M4,3
            C2.8,3.1,1.9,4.1,2,5.3l0,13.5c-0.1,1.2,0.8,2.2,2,2.3h16c1.2-0.1,2.1-1.1,2-2.3V5.3c0.1-1.2-0.8-2.2-2-2.3H4z M12,13.1L12,13.1
            L4,7.5V5.3l8,5.6l8-5.6v2.3L12,13.1L12,13.1z">
          </path>
        </svg>
      </a>
      <a href="tel:+4915773577671" aria-label="Maikes Familienbegleitung anrufen" target="_blank" rel="noopener">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" role="img" aria-label="Telefon-Symbol">
          <path d="M20,24H4c-2.2,0-4-1.8-4-4V4c0-2.2,1.8-4,4-4h16c2.2,0,4,1.8,4,4v16C24,22.2,22.2,24,20,24z M4,3
            C3.4,3,3,3.4,3,4c0,9.4,7.6,17,17,17c0.6,0,1-0.4,1-1v-3.5c0-0.6-0.4-1-1-1c-1.2,0-2.4-0.2-3.6-0.6c-0.1,0-0.2-0.1-0.3-0.1
            c-0.3,0-0.5,0.1-0.7,0.3l-2.2,2.2c-1.4-0.7-2.7-1.7-3.8-2.8c-1.1-1.1-2.1-2.4-2.8-3.8l2.2-2.2c0.3-0.3,0.4-0.7,0.3-1
            C8.7,6.4,8.5,5.2,8.5,4c0-0.6-0.4-1-1-1H4z">
          </path>
        </svg>
      </a>
      <a href="https://wa.me/4915773577671?text=Liebe%20Maike%2C%20ich%20habe%20eine%20Frage%20zu%20..." aria-label="WhatsApp Chat mit Maikes Familienbegleitung starten" target="_blank" rel="noopener">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512" role="img" aria-label="WhatsApp-Symbol">
          <path d="M512,382.07c0,2.8-.09,8.88-.26,13.58-.41,11.49-1.32,26.32-2.7,33.07a109.76,109.76,0,0,1-9.27,27.71,98.45,98.45,0,0,1-43.43,43.39,110.21,110.21,0,0,1-27.87,9.28c-6.69,1.35-21.41,2.24-32.82,2.65-4.71.17-10.79.25-13.58.25l-252.1,0c-2.8,0-8.88-.09-13.58-.26-11.49-.41-26.32-1.32-33.07-2.69a110.37,110.37,0,0,1-27.72-9.28A98.5,98.5,0,0,1,12.18,456.3,110.21,110.21,0,0,1,2.9,428.43C1.55,421.74.66,407,.25,395.61.08,390.91,0,384.82,0,382l0-252.1c0-2.8.09-8.88.25-13.58C.71,104.86,1.62,90,3,83.28a110.37,110.37,0,0,1,9.27-27.72A98.59,98.59,0,0,1,55.7,12.18,110.21,110.21,0,0,1,83.57,2.9C90.26,1.55,105,.66,116.39.25,121.09.08,127.18,0,130,0l252.1,0c2.8,0,8.88.09,13.58.25C407.14.71,422,1.62,428.72,3a110.37,110.37,0,0,1,27.72,9.27A98.59,98.59,0,0,1,499.82,55.7a110.21,110.21,0,0,1,9.28,27.87c1.35,6.69,2.24,21.41,2.65,32.82.17,4.7.25,10.79.25,13.58Z"/>
          <path fill=var(--primary-color) d="M379.56,131.67A172.4,172.4,0,0,0,256.67,80.73C161,80.73,83.05,158.64,83.05,254.42a173.47,173.47,0,0,0,23.2,86.82l-24.65,90,92.08-24.17a173.55,173.55,0,0,0,83,21.17h.07c95.73,0,173.69-77.91,173.69-173.69A172.73,172.73,0,0,0,379.53,131.7l0,0ZM256.72,399a144.17,144.17,0,0,1-73.52-20.14l-5.29-3.15L123.27,390l14.59-53.27-3.42-5.47a143.29,143.29,0,0,1-22.11-76.81C112.33,174.81,177.1,110,256.8,110A144.34,144.34,0,0,1,401.12,254.48c-.07,79.67-64.83,144.46-144.41,144.46v0ZM335.87,290.8c-4.32-2.2-25.68-12.67-29.65-14.12s-6.85-2.19-9.8,2.2-11.22,14.11-13.76,17-5.06,3.29-9.37,1.09-18.35-6.77-34.92-21.56c-12.88-11.5-21.61-25.74-24.15-30s-.29-6.71,1.92-8.83c2-1.93,4.32-5.06,6.51-7.6s2.88-4.32,4.32-7.26.74-5.42-.35-7.6-9.8-23.55-13.34-32.25c-3.49-8.51-7.12-7.32-9.79-7.47s-5.42-.13-8.29-.13a16,16,0,0,0-11.57,5.41c-4,4.32-15.2,14.86-15.2,36.22s15.54,42,17.72,44.91,30.61,46.76,74.14,65.54c10.34,4.44,18.42,7.11,24.72,9.18a60,60,0,0,0,27.32,1.71c8.35-1.23,25.68-10.49,29.31-20.62s3.63-18.83,2.55-20.62-3.91-3-8.29-5.22l0,0Z"/>
        </svg>
      </a>
    </div>
  </footer>
</template>

<script>
  export default {
  name: 'Footer',
  data() {
    return {
      currentYear: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.footer {
  text-align: center;
  padding: 1.25rem; /* 20px */
  color: var(--secondary-font-color);
  background-color: var(--primary-color);
  margin-top: 1.25rem; /* 20px */
}

.footer-links {
  margin-bottom: 0.625rem; /* 10px */
}

.footer-links a {
  color: var(--secondary-font-color);
  text-decoration: none;
  margin: 0 0.3125rem; /* 0 5px */
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-copyright {
  margin-bottom: 0.625rem; /* 10px */
  color: var(--font-color-light);
}

.footer-social a {
  margin: 0 0.25rem; /* 0 4px */
}

.footer-social svg {
  fill: var(--secondary-font-color);
  width: 2.25rem; /* 36px */
  height: 2.25rem; /* 36px */
}
</style>